module.exports = __webpack_public_path__ + "img/Feature.e1d83ba7.jpg";